import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Box,
    Typography,
    Container,
    Card,
    CardMedia,
    CircularProgress,
    Grid,
} from "@mui/material";

function BusinessProcess() {
    const [businessprocess, setBusinessprocess] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios
            .get("/files/enterpriseMobility/business_process.txt")
            .then((res) => {
                setBusinessprocess(res.data);
                setLoading(false);
            })
            .catch((err) => {
                console.error("Error fetching data:", err);
                setLoading(false);
            });
    }, []);

    return (
        <Container maxWidth="lg" sx={{ py: 2 }}>
            {/* Title */}
            <Typography
                variant="h3"
                align="center"
                gutterBottom
                sx={{
                    fontWeight: "bold",
                    color: "#030366",
                    mt: 7,
                    fontSize: {
                        xs: "1.8rem",  // mobile (~h4)
                        sm: "2.2rem",  // tablet (~h3)
                        md: "2.8rem",  // laptop (~h3+)
                        lg: "3rem",    // desktop (~h2)
                    },
                }}
            >
                Business Process Mobilization
            </Typography>

            {loading ? (
                <Box display="flex" justifyContent="center" mt={4}>
                    <CircularProgress color="secondary" />
                </Box>
            ) : (
                <Grid container spacing={4} alignItems="flex-start">
                    {/* Content Section */}
                    <Grid item xs={12} md={7}>
                        {businessprocess &&
                            businessprocess.map((data, index) => (
                                <Typography
                                    key={index}
                                    variant="body1"
                                    sx={{
                                        mb: 2,
                                        textAlign: "justify",
                                        fontSize: "18px",
                                    }}
                                >
                                    {data}
                                </Typography>
                            ))}
                    </Grid>
                </Grid>
            )}
        </Container>
    );
}

export default BusinessProcess;
